import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function SocialProof() {
  const stats = [{
    value: '+150',
    label: 'Spas y Clínicas Transformados'
  }, {
    value: '3.2x',
    label: 'Retorno Promedio de Inversión'
  }, {
    value: '+$2M',
    label: 'Generados Para Nuestros Clientes'
  }, {
    value: '94%',
    label: 'Tasa de Retención de Clientes'
  }];
  return <section className="py-20 px-4 bg-surface border-t border-border relative overflow-hidden" data-id="element-199">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-200">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-201">
          <h2 className="text-3xl md:text-4xl font-bold text-gold tracking-tight mb-4" data-id="element-202">
            Resultados Que Hablan Por Sí Solos
          </h2>
          <p className="text-neutral-400 text-lg md:text-xl max-w-2xl mx-auto" data-id="element-203">
            Números reales de spas reales. Sin trucos, sin inflaciones.
          </p>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-204">
          {stats.map((stat, index) => <motion.div key={index} variants={itemVariants} className="bg-carbon border border-border rounded-2xl p-8 text-center flex flex-col items-center justify-center shadow-lg hover:border-gold/20 transition-colors" data-id="element-205">
              <span className="text-5xl md:text-6xl font-black text-gold mb-4 tracking-tighter" data-id="element-206">
                {stat.value}
              </span>
              <span className="text-neutral-300 font-medium text-lg leading-snug" data-id="element-207">
                {stat.label}
              </span>
            </motion.div>)}
        </motion.div>

        <motion.div className="text-center" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} data-id="element-208">
          <p className="text-neutral-400 text-lg md:text-xl font-medium italic" data-id="element-209">
            "Sin contratos a largo plazo. Sin riesgo. Solo resultados."
          </p>
        </motion.div>
      </div>
    </section>;
}